// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1OUSO","detailsBorder":"styles_detailsBorder__3B_od"};